import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  backgroundColor = signal<'#3a5d4d' | 'transparent'>('transparent');
  initialColor = signal<'#3a5d4d' | 'transparent'>('transparent');

  setGreenBackground(): void {
    this.backgroundColor.set('#3a5d4d');
    this.initialColor.set('#3a5d4d');
  }

  setTransparentBackground(): void {
    this.backgroundColor.set('transparent');
    this.initialColor.set('transparent');
  }

  setBackgroundColor(color: '#3a5d4d' | 'transparent'): void {
    this.backgroundColor.set(color);
  }
}
